  <!-- Animated -->
            <div class="animated fadeIn">

                <!--  Traffic  -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-body" style="min-height: 600px;">
                                <h4 class="box-title">Flash Upload</h4>
                                <!--<a class="float-right rtbtn btn btn-primary" style="margin-top: -35px;" (click)="logout()">Logout</a>-->
                           <br/>
                                <div class="row form-group">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                       Organization
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                    	{{companyName}}
                                        <select name="selectSm" id="selectSm" class="form-control-sm form-control" [(ngModel)]="company" *ngIf="companyName==''" (change)="chngCompId()">
                                            <option value="{{cdetails.companyId}}" *ngFor="let cdetails of compData"  >{{cdetails.companyName}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row form-group" id="fileYearCont" >
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Year
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="fileYear" id="fileYear" [(ngModel)]="fileYear"
                                                class="form-control-sm form-control" disabled>
                                            <option value="{{yr}}" *ngFor="let yr of yearArr">{{yr}}</option>
                                        </select>
                                        <span style="color:red;font-weight: strong;">{{fileYearErr}}</span>
                                    </div>
                                </div>

                                <div class="row form-group"  id="selectMonthCont">
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Month
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                        <select name="selectMonth" id="selectMonth" [(ngModel)]="selectMonth"
                                                class="form-control-sm form-control" disabled>
                                            <option value="">Please select</option>
                                            <option value="January">January</option>
                                            <option value="February">February</option>
                                            <option value="March">March</option>
                                            <option value="April">April</option>
                                            <option value="May">May</option>
                                            <option value="June">June</option>
                                            <option value="July">July</option>
                                            <option value="August">August</option>
                                            <option value="September">September</option>
                                            <option value="October">October</option>
                                            <option value="November">November</option>
                                            <option value="December">December</option>
                                        </select>
                                        <span style="color:red;font-weight: strong;">{{selectMonthErr}}</span>
                                    </div>
                                </div>
                                <div class="row form-group" id="forTheMonthCont" >
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        For the Month <br>
                                        <span>(in Rupees Crores)</span>
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                         <input name="forTheMonth" appTwoDigitDecimaNumberDirective [(ngModel)]="forTheMonth" id="forTheMonth" class="form-control-sm form-control" required />
                                          <span style="color:red;font-weight: strong;">{{forTheMonthErr}}</span>
                                    </div>
                                </div>
                                <div class="row form-group" id="forTheMonthPrevYrCont" >
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        For the Month (Prev Year)<br>
                                        <span>(in Rupees Crores)</span>
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                         <input name="forTheMonthPrevYr" appTwoDigitDecimaNumberDirective [(ngModel)]="forTheMonthPrevYr" id="forTheMonthPrevYr" class="form-control-sm form-control" required />
                                         <span style="color:red;font-weight: strong;">{{forTheMonthPrevYrErr}}</span>
                                    </div>
                                </div>
                                <div class="row form-group" id="uptoMonthCont" >
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Cumulative Upto the Month <br>
                                        <span>(in Rupees Crores)</span>
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                         <input name="uptoMonth"  appTwoDigitDecimaNumberDirective [(ngModel)]="uptoMonth" id="uptoMonth" class="form-control-sm form-control" required />
                                         <span style="color:red;font-weight: strong;">{{uptoMonthErr}}</span>
                                    </div>
                                </div>
                                <div class="row form-group" id="uptoMonthPrevYrCont" >
                                    <div class="col col-md-3"><label for="selectSm" class=" form-control-label">
                                        Cumulative Upto the Month (Prev Year) <br>
                                        <span>(in Rupees Crores)</span>
                                    </label></div>
                                    <div class="col-12 col-md-9">
                                         <input name="uptoMonthPrevYr"  appTwoDigitDecimaNumberDirective [(ngModel)]="uptoMonthPrevYr" id="uptoMonthPrevYr" class="form-control-sm form-control" required />
                                         <span style="color:red;font-weight: strong;">{{uptoMonthPrevYrErr}}</span>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col col-md-3"></div>
                                    <div class="col-12 col-md-6">
                                        <div class="form-actions form-group">
                                            <button type="submit" class="btn btn-primary btn-sm" (click)="uploadFile()">Submit</button>
                                        </div>
                                    </div>


                                </div>



                                <!--<div class="row form-group" *ngIf="hasError">
                                    <div class="col col-md-12">
                                        <div class="card border border-success">
                                            <div class="card-header">
                                                <strong class="card-title">Unsuccessful Upload – Error messages below</strong>
                                            </div>
                                            <div class="card-body" id="errCont">
                                                <p class="card-text" *ngFor="let err of errMsg">{{err}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>-->


                            </div>
                        </div>
                    </div><!-- /# column -->
                </div>
                <!--  /Traffic -->
                <div class="clearfix"></div>




            </div>
            <!-- .animated -->





<!--
<div class="loaderbox" *ngIf="loaderVisibility">
    <div class="load">
        <img src="assets/images/loading.gif" alt="">
    </div>
</div>-->



















